// myVariable.js
// const APINAME = 'http://localhost:3001/files/';
const APINAME = 'https://api.hugsangbaan.com/files/';

export default APINAME;


